import type { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

import { stats } from 'nextjs/getServerSideProps';
import PageNextJs from 'nextjs/PageNextJs';

import Stats from 'ui/pages/Stats';

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/stats">
      <Stats/>
    </PageNextJs>
  );
};

export default Page;

// export { stats as getServerSideProps } from 'nextjs/getServerSideProps';

export const getServerSideProps = async(context) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale, [ 'common' ])),
      ...(await stats(context)),
    },
  };
};
